import { saveTask, removeTask, getTasksForComponent } from '../../../services/taskPersistence';
import { isMeetingActive } from '../../meetBot';
import { extractLink } from '../routeLink';

/**
 * Источник «встреча»: бот заходит гостем, объявляет о записи, пишет звук и
 * после встречи кладёт расшифровку в Историю.
 *
 * Отличается от остальных источников тем, что ждёт часами. Поэтому встреча
 * запоминается на диске и переживает перезагрузку вкладки: иначе человек
 * видит пустую форму и зовёт второго бота на ту же встречу.
 */

const PERSIST_KEY = 'recognition-meeting';

// 🔴 Своё время жизни, а не общий час taskPersistence: встреча идёт до
// четырёх часов (bit-meetbot MAX_MEETING_SEC), после неё ещё диаризация, а
// GET /meetings/{id} отвечает все сутки (MEETING_TASK_TTL_SEC).
export const MEETING_TTL_MS = 24 * 60 * 60 * 1000;

async function start({ url: pasted, displayName = null }, { post, baseUrl }) {
  // Ссылка, а не вставленный текст: её экран покажет адресом и сохранит.
  const url = extractLink(pasted);
  // Имя из формы едет телом: бот подписывается им, а не кэшированным профилем.
  const response = await post(`${baseUrl}/join`, displayName ? { url, display_name: displayName } : { url });
  const meetingId = response.data.meeting_id;

  const startedAt = Date.now();
  saveTask({
    taskId: meetingId,
    component: PERSIST_KEY,
    startedAt: new Date(startedAt).toISOString(),
    // Ссылка нужна экрану, чтобы сказать, за какой встречей следит бот: если
    // их несколько, по одному «Бот на встрече» это не понять.
    url,
    ttlMs: MEETING_TTL_MS,
  });

  // Состояние и что можно делать — из ответа сервиса: кнопки экрана решает он.
  return { meetingId, url, startedAt, platform: response.data.platform, kind: 'meeting',
           state: response.data.state || 'JOINING',
           can_stop: response.data.can_stop, can_start_new: response.data.can_start_new };
}

/** Встреча, начатая до перезагрузки вкладки, либо null. */
function restore() {
  const [saved] = getTasksForComponent(PERSIST_KEY);
  if (!saved) return null;
  // Время начала возвращаем настоящее: без него таймер после перезагрузки
  // стартовал с нуля и врал про длительность встречи.
  const startedAt = Date.parse(saved.startedAt);
  return {
    meetingId: saved.taskId,
    url: saved.url || null,
    startedAt: Number.isNaN(startedAt) ? null : startedAt,
    kind: 'meeting',
  };
}

async function status({ meetingId }, { get, baseUrl }) {
  const response = await get(`${baseUrl}/meetings/${encodeURIComponent(meetingId)}`);
  // Встреча кончилась — восстанавливать больше нечего.
  if (!isMeetingActive(response.data.state)) removeTask(meetingId);
  return response.data;
}

async function stop({ meetingId }, { post, baseUrl }) {
  // Ручная остановка именно просит сервис убрать бота из комнаты: смена
  // надписи на экране оставила бы его сидеть на встрече до штатного конца.
  const response = await post(`${baseUrl}/meetings/${encodeURIComponent(meetingId)}/stop`, {});
  return response.data;
}

/** Забыть встречу — «записать ещё одну» и уход с экрана. */
function forget(meetingId) {
  if (meetingId) removeTask(meetingId);
}

export const meetingSource = { key: 'meeting', start, restore, status, stop, forget };
